import PageLayout from 'pages/InstructorFormativeSubmissions/PageLayout';
import PageProvider from 'pages/InstructorFormativeSubmissions/PageProvider';

const InstructorFormativeSubmissions = ({ ...props }) => {
    return (
        <PageProvider {...props}>
            <PageLayout {...props} />
        </PageProvider>
    );
};

export default InstructorFormativeSubmissions;
